// Traduções do site público: window.__i18n (chave pt_BR => tradução) é injetado pelo layout.
// Sem tradução (ou em pt_BR) devolve a própria chave. Placeholders no formato :name.
export function t(key, replace = {}) {
    const dict = window.__i18n || {};
    let text = Object.prototype.hasOwnProperty.call(dict, key) ? dict[key] : key;
    for (const [name, value] of Object.entries(replace)) {
        text = text.split(':' + name).join(String(value));
    }
    return text;
}

window.t = t;
